import PDFIcon from '../../../images/icons/pdf.min.svg';
import XICon from '../../../images/icons/x.min.svg';
import ExeIcon from '../../../images/icons/exe.min.svg';
import DocumentIcon from '../../../images/icons/doc.min.svg';
import TFRIcon from '../../../images/icons/tfr.min.svg';
import VideoIcon from '../../../images/icons/video.min.svg';
import ImageIcon from '../../../images/icons/image.min.svg';
import DefaultIcon from '../../../images/icons/default.min.svg';
import ZipIcon from '../../../images/icons/zip.min.svg';

const iconForFile = (file) => {
  if (!file) {
    return DefaultIcon;
  }

  const { fileType, filename, mime } = file;
  const last = filename ? filename.split('.').pop() : undefined;
  const extension = typeof last === 'string' ? last.toLowerCase() : last;
  const [typePre, typePost] = typeof mime === 'string' ? mime.split('/') : 'n/a';

  if (fileType === 'comtrade') {
    return TFRIcon;
  }

  if (fileType === 'pdf' || fileType === 'application/pdf') {
    return PDFIcon;
  }

  if (['doc', 'docx', 'docm'].includes(extension)) {
    return DocumentIcon;
  }

  if (['xls', 'xlsx', 'xlsb', 'xlsm'].includes(extension)) {
    return XICon;
  }

  if (extension === 'zip') {
    return ZipIcon;
  }

  if (extension === 'exe') {
    return ExeIcon;
  }

  if (fileType === 'video' || typePre === 'video' || typePost === 'video') {
    return VideoIcon;
  }

  if (typePre === 'image' || typePost === 'image') {
    return ImageIcon;
  }

  return DefaultIcon;
};

const FiletypeIcon = ({ file, ...properties }) => (
  <div
    data-testid="filetype-icon"
    className="filetype-icon-component"
    {...properties}
  >
    <img src={iconForFile(file)} />
  </div>
);

export default FiletypeIcon;
